import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { EcommerceCategories, RemoteConfig } from '../../models';
import { ecommerceCategories, remoteConfigs } from './remote-configs.mock';
import { RemoteConfigsService } from './remote-configs.service';

@Injectable()
export class RemoteConfigsServiceMock implements RemoteConfigsService {
  constructor() {}

  get(): Observable<RemoteConfig | null> {
    return of(remoteConfigs).pipe(delay(1000));
  }

  getEcommerceCategories(): Promise<EcommerceCategories | null> {
    return Promise.resolve(ecommerceCategories);
  }
}